import React from 'react';

import { ManifestationTable } from '../ManifestationTable';
import { ManifestationHeader } from './ManifestationHeader';
import { ManifestationDataProps } from '../../../store/ducks/manifestations/types';
import { FiltersProps, HandleDetailProps } from '..';

interface Props {
  data?: ManifestationDataProps[];
  filters: FiltersProps;
  showManifestationTable?: boolean;
  onSearch: () => void;
  onDetail: (data: HandleDetailProps) => void;
  onFilter: (column: keyof ManifestationDataProps, value: string) => void;
}

export const ManifestationTracking = ({
  data,
  filters,
  showManifestationTable,
  onSearch,
  onDetail,
  onFilter
}: Props) => {
  if (showManifestationTable) {
    return null;
  }

  return (
    <>
      <ManifestationHeader onSearch={onSearch} />

      <ManifestationTable
        filters={filters}
        data={data}
        onDetail={onDetail}
        onFilter={onFilter}
      />
    </>
  );
};
